import React, { useCallback } from 'react';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Promote pillar; each part uses its own slice of it */
import styles from '../Promote.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ComposerCaptionFieldProps {
  /** The tab this box belongs to, read out to screen readers. */
  label: string;
  value: string;
  disabled?: boolean;
  onChange: (value: string) => void;
}

/** The one box the copy is written in. The tabs above say which copy it is. */
const ComposerCaptionFieldComponent: React.FC<ComposerCaptionFieldProps> = ({ label, value, disabled, onChange }) => {
  const change = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => onChange(event.target.value),
    [onChange]
  );

  return (
    <textarea className={styles.captionArea} value={value} disabled={disabled} aria-label={label} onChange={change} />
  );
};

export const ComposerCaptionField = TypedMemo(ComposerCaptionFieldComponent);
